import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { useT } from "@/i18n";

export default function HowToPlayDialog({ open, onOpenChange }) {
  const { t } = useT();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="howto-dialog"
        className="max-w-xl bg-black/70 backdrop-blur-2xl border border-white/10 text-white rounded-none"
      >
        <DialogHeader>
          <DialogTitle className="font-display text-3xl tracking-tighter glow-cyan">
            {t("howto.title")}
          </DialogTitle>
          <DialogDescription className="text-white/60 tracking-wide">
            {t("howto.subtitle")}
          </DialogDescription>
        </DialogHeader>
        <div className="mt-4 space-y-4 text-sm">
          <Row k={t("howto.move")} v={t("howto.move_v")} c="#00F0FF" />
          <Row k={t("howto.pause")} v={t("howto.pause_v")} c="#00F0FF" />
          <Row k={t("howto.goal")} v={t("howto.goal_v")} c="#39FF14" />
          <Row k={t("howto.avoid")} v={t("howto.avoid_v")} c="#FF0055" />
          <Row k={t("howto.collect")} v={t("howto.collect_v")} c="#FFD400" />
          <div className="pt-2 text-xs text-white/60">
            {t("howto.footer")}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

function Row({ k, v, c }) {
  return (
    <div className="flex justify-between items-center border-b border-white/5 pb-2 gap-3">
      <span className="text-[11px] tracking-[0.3em] text-white/50 shrink-0">{k}</span>
      <span className="text-sm font-medium text-right" style={{ color: c }}>
        {v}
      </span>
    </div>
  );
}
